import { combineReducers } from 'redux';
import clickHistory from './clickHistory';
import allMerchants from './allMerchants';

export default combineReducers({
  clickHistory,
  allMerchants,
});
